module.exports = __webpack_public_path__ + "static/media/mobile-logo.199069b1.png";